import { useCluster, useRegionConfig } from "in_queue/contexts/ClusterContext";
import { useAllAvailableProjects } from "in_queue/contexts/ProjectDataContext";
import { isOnlyExclusionSupported } from "in_queue/types/configPerRegion";
import { isPriorQueueProject } from "in_queue/types/projectType";
import { useMemo } from "react";

/**
 * Prior-queue projects whose ERIS is withdraw-only. Empty on exclusion-only
 * stages, where ERIS is already all-or-nothing.
 */
export const useCapacityOnlyProjectIds = (): ReadonlySet<string> => {
    const cluster = useCluster();
    const componentConfig = useRegionConfig();
    const allProjects = useAllAvailableProjects();
    return useMemo(
        () =>
            new Set(
                isOnlyExclusionSupported(cluster) ||
                !componentConfig.strictSizeRulesEnabled ||
                allProjects === "loading"
                    ? []
                    : allProjects
                          .filter((project) =>
                              isPriorQueueProject(project.cluster, cluster)
                          )
                          .map((project) => project.projectId)
            ),
        [allProjects, cluster, componentConfig]
    );
};
